export default __webpack_public_path__ + "static/media/SpheroEdu.8053e4d1.webp";